/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable } from '@angular/core';
import { UserContext } from '@irian-ro/util-user';
import { Router } from '@angular/router';
import {
  getCustomerOfferRequestAndOrderRights,
  getCustomerRights,
  getEFacturaPageRights,
  getFleetRights,
  getServiceProviderGeneralRights,
  getServiceProviderOfferRequestAndOrderRights,
  Rights
} from '@well/rights';
import { LoggedInContext } from '@well/shared-providers';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  userContext = inject(UserContext);
  router = inject(Router);

  navigateByRights(context: LoggedInContext) {
    if (context.loggedInUser?.authType === 'authEmail') {
      if (context.serviceProvider === true) {
        this.router.navigate(['/delivery/offer-request/service-provider-offer-request']);
      } else {
        this.router.navigate(['/delivery/offer-request/customer-offer-request']);
      }
      return;
    }

    const rightsRouteMap: { rights: Rights[]; route: string }[] = [
      { rights: getServiceProviderGeneralRights(), route: '/delivery/delivery-inbox' },
      { rights: getCustomerRights(), route: '/delivery/delivery-outbox' },
      { rights: [Rights.ROLE_ETRANSPORT], route: '/delivery/etransport' },
      { rights: [Rights.ROLE_ETRANSPORT_SHIPMENT_ORGANIZER], route: '/delivery/etransport/organizer/list' },
      { rights: getServiceProviderOfferRequestAndOrderRights(), route: '/delivery/invoice/sp' },
      { rights: getCustomerOfferRequestAndOrderRights(), route: '/delivery/invoice/customer' },
      { rights: getEFacturaPageRights(), route: '/delivery/efactura/list' },
      { rights: getFleetRights(), route: '/delivery/vehicle' }
    ];

    for (const { rights, route } of rightsRouteMap) {
      if (this.userContext.hasAnyRights(rights)) {
        this.router.navigate([route]);
        return;
      }
    }

    this.router.navigate(['/delivery/entry']);
  }
}
